import axios from 'axios'
import router from '../../../router/index'

const api = process.env.VUE_APP_URL;

export default {
  namespaced: true,
  state() {
    return {
      //список вещей
      ownedThing: [],
      assignedThings: [],
      device: '',
      dirName: '',
      allThingsFromGetOwned: [],

      //things toggler
      activeSectionThings: 'owned',
      checkedThingList: [],

      //merge group
      isMergeGroup: false,
      mergeGroupId: '',

      isMergeVirtual: false,
      mergeVirtualId: '',

      //del
      showDel: false,
      delName: [],
      confirm: false,

      //share
      showShare: false,
      shareName: '',
      showShareUsers: true,
      showShareRoles: true,
      shareDeviceType: 'thing',

      //rights control
      showRightsControl: false,
      defaultRight: '',
      rightsType: 'user',
      deviceType: 'device',

      //change owner
      showChangeOwner: false,

      //errors merge
      errorMergeThing: false,

      //состояние редактирования хедера в свойствах ноды projectHeader
      isHeaderSettingsEditActive: false,
      //состояние редактирования свойста ноды thingSettings
      onSettingsNodeEdit: false,
      //инпутc в состоянии редактирования
      onEditingInputs: {},
      //для загрузки нового аватара вещи перед отправкой
      newAvatar: '',



      allThingsTags: '',
      activeThingsTags: '',

      // checkedThings: [],

      //состояние отображаемого списка вещей, чтобы сравнить с выбранными в хедере вещей (для отображения чекнутых)
      displayedNowThings: [],
    }
  },
  getters: {
    getDirName(state) {
      return state.dirName
    },
    // getterAllThings(state) {
    //   return state.allDevices
    // },
    firstLevelThings(state) {
      let arr = [];
      let parentArr;
      if (state.activeSectionThings === 'owned') {
        parentArr = state.ownedThing
      } else {
        parentArr = state.assignedThings;
      };
      /*if (parentArr && parentArr.groups && parentArr.devices) {
        for (let i = 0; i < parentArr.groups.length; i++) {
          let item = parentArr.groups[i];
          item.type = 'group';
          arr.push(item);
        }
        ;
        for (let i = 0; i < parentArr.devices.length; i++) {
          let item = parentArr.devices[i];
          if (item.virtual) {
            item.type = 'virtual'
          } else {
            item.type = 'thing'
          };
          arr.push(item);
        }
        ;
      }*/
      if (parentArr) {
        for (let i = 0; i < parentArr.length; i++) {
          let item = parentArr[i];
          if (item.virtual) {
            item.type = 'virtual'
          } else {
            item.type = 'thing'
          };
          arr.push(item);
        }
        ;
      }
      return arr;
    },
    tree(state) {
      let arr = [];

      function getVal(obj) {
        getProp(obj);

        function getProp(o) {
          for (let key in o) {
            if (typeof(o[key] === 'object')) {
              getProp(o[prop])
            } else {
            }
          }
        }
      };

      function setSettingsFroThing(item) {
        if (item.virtual) {
          item.dragDisabled = true;
          item.addTreeNodeDisabled = true;
          item.delNodeDisabled = true;
          item.editNodeDisabled = false;
          item.addLeafNodeDisabled = true;
          item.pid = 0;
        } else {
          item.isLeaf = true;
          item.disabled = true;
          item.delNodeDisabled = true;
          item.editNodeDisabled = true;
          item.addLeafNodeDisabled = true;
          item.pid = 0;
        };
        return item
      };

      function setSettingsForGroup(item) {
        item.dragDisabled = false;
        item.delNodeDisabled = true;
        item.editNodeDisabled = true;
        item.addLeafNodeDisabled = true;
        item.addTreeNodeDisabled = true;
        item.pid = 0;
        return item
      }

      function addLeaf(arr) {
        //вызываем функцию
        getItem(arr);

        function getItem(a) {
          //проходим по массиву
          for (let j = 0; j < a.length; j++) {
            //если вешь вирутальная
            if (a[j].virtual) {
              //добавляем инфу для дерева
              a[j] = setSettingsFroThing(a[j]);
              //вызываем рекурсивно
              getItem(a[j].children);
            } else {
              //просто вещь. инфа для дерева
              a[j] = setSettingsFroThing(a[j])
            }
          }
        }
      };

      function appendGroupsInChildren(arr) {
        getItem(arr);

        function getItem(a) {
          for (let j = 0; j < a.length; j++) {
            let item = a[j];
            let children = item.children;
            let groups = item.groups;
            item.type = 'group';
            //присваиваем тип
            for (let k = 0; k < groups.length; k++) {
              groups[k].type = 'group';
            };
            for (let k = 0; k < groups.length; k++) {
              children.push(groups[k])
            }
            if (groups) {
              getItem(groups)
            }
          }
        }
      };

      function tuneGroups(arr) {
        getItem(arr);

        function getItem(a) {
          for (let j = 0; j < a.length; j++) {
            let item = a[j];
            if (item.type === 'group') {
              item = setSettingsForGroup(item);
            };
            if (item.virtual) {
              item = setSettingsFroThing(item)
            }

            if (item.children.length > 0) {
              getItem(item.children)
            } else {
              if (item.virtual) {
                item = setSettingsFroThing(item);
                getItem(item.children)
              } else if(!item.virtual && item.type !== 'group') {
                item = setSettingsFroThing(item)
              };

              if (item.type === 'group') {
                item = setSettingsForGroup(item);
              }
            };

            item.children = item.children.reverse();
          }
        }
      };

      if (state.ownedThing && state.ownedThing.devices && state.ownedThing.groups) {
        let things;
        let groups;
        if (state.activeSectionThings === 'owned') {
          things = state.ownedThing.devices;
          groups = state.ownedThing.groups;
        } else {
          things = state.assignedThings.devices;
          groups = state.assignedThings.groups
        }
        ;

        if (things && groups) {
          //группы вещей
          let groupsString = JSON.stringify(groups)
            .replace(/included_devices/g, 'children')
            //.replace(/groups/g, 'children')
            .replace(/devices/g, 'children');
          groupsString = JSON.parse(groupsString);
          appendGroupsInChildren(groupsString);
          tuneGroups(groupsString);

          for (let i = 0; i < groupsString.length; i++) {
            arr.push(groupsString[i]);
          };

          //вещи
          //меняем included_devices на childrens простым реплейсом
          let thingsString = JSON.stringify(things).replace(/included_devices/g, 'children');
          //парсим
          thingsString = JSON.parse(thingsString);
          //добавляем нужные для дерева свойства
          addLeaf(thingsString);
          //пихаем в массив
          for (let i = 0; i < thingsString.length; i++) {
            arr.push(thingsString[i])
          };
        };

        function setType(array) {
          sortChild(array);

          function sortChild(a) {
            for (let i = 0; i < a.length; i++) {
              let item = a[i];
              if (item.virtual) {
                item.type = 'virtual'
              } else {
                item.type = 'thing'
              };

              if (item.groups) {
                item.type = 'group'
              };

              if (item.children.length > 0) {
                sortChild(item.children)
              }
            }
          }
        };
        function sortArr(array) {
          sortChild(array);

          function sortChild(a) {
            for (let i = 0; i < a.length; i++) {
              let item = a[i];

              item.children = item.children.sort((a1,b) => {
                if ((a1.type == 'group' && (b.type == 'thing' || b.type == 'virtual') || (a1.type == 'thing' && b.type == 'virtual'))) {
                  return -1
                };

                if ((b.type == 'group' && (a1.type == 'thing' || a1.type == 'virtual') || (b.type == 'thing' && a1.type == 'virtual'))) {
                  return 1
                }

                return 0
              });

              if (item.children.length > 0) {
                sortChild(item.children)
              }
            }

          }
        }

        setType(arr);
        sortArr(arr);

        arr = arr.sort((a1,b) => {
          if ((a1.type == 'group' && (b.type == 'thing' || b.type == 'virtual') || (a1.type == 'thing' && b.type == 'virtual'))) {
            return -1
          };

          if ((b.type == 'group' && (a1.type == 'thing' || a1.type == 'virtual') || (b.type == 'thing' && a1.type == 'virtual'))) {
            return 1
          }

          return 0
        });


      };
      return arr;
    }
  },
  mutations: {
    SET_CHECKED_THINGS(state,data) {
      state.checkedThings = data
    },
    //получение девайсов своего аккаунта (которые в своих проектах)
    SET_OWNED_THINGS(state,data) {
      const allDevices = []
      let ownerRoleId
      //откуда берется arr? где он тут приходит?
      let getDevices = (arr) => {
        if (arr.owner_role_id) {
          ownerRoleId = arr.owner_role_id
        }
        if (arr.items.length > 0) {
          for (let i = 0; i < arr.items.length; i++) {
            if (arr.items[i].devices.length > 0) {
              for (let j = 0; j < arr.items[i].devices.length; j++) {
                let device = arr.items[i].devices[j]
                if (arr.owner_role_id) {
                  device.owner_role_id = arr.owner_role_id
                } else {
                  device.owner_role_id = ownerRoleId
                }
                allDevices.push(device)
              }
            }
            if (arr.items[i].items.length > 0) {
              getDevices(arr.items[i])
            }
          }
        }
      }

      for (let i = 0; i < data.projects.length; i++) {
        getDevices(data.projects[i])
      }
      state.ownedThing = allDevices
    },

    SET_ALL_DEVICES(state,data) {
      state.allThingsFromGetOwned = data
    },
    SET_ALL_DEVICES_TAGS(state,data) {
      state.allThingsTags = data;
    },
    SET_ASSIGNED_THINGS(state,data) {
      state.assignedThings = data
    },
    SET_ACTIVE_SECTION(state,data) {
      state.activeSectionThings = data
    },
    SET_ACTIVE_TAGS(state,data){
      state.activeThingsTags = data
    },
    SET_CHECKED_THINGS_LIST(state,data) {
      state.checkedThingList = data
    },
    SET_ERROR_MERGE_THING(state,data) {
      state.errorMergeThing = data
    },
    SET_MERGE_GROUP(state,data) {
      state.isMergeGroup = data
    },
    SET_MERGE_GROUP_ID(state,data) {
      state.mergeGroupId = data
    },
    SET_MERGE_VIRTUAL(state,data) {
      state.isMergeVirtual = data
    },
    SET_MERGE_VIRTUAL_ID(state,data) {
      state.mergeVirtualId = data
    },
    SET_DEVICE(state,data) {
      state.device = data
    },
    SET_DIR_NAME(state,data) {
      state.dirName = data
    },
    SET_SHOW_DEL(state,data) {
      state.showDel = data
    },
    SET_DEL_NAME(state,data) {
      state.delName = data
    },
    SET_CONFIRM(state,data) {
      state.confirm = data
    },
    SET_SHOW_SHARE(state,data) {
      state.showShare = data
    },
    SET_SHARE_NAME(state,data) {
      state.shareName = data
    },
    SET_SHARE_USERS(state,data) {
      state.showShareUsers = data
    },
    SET_SHARE_ROLES(state,data) {
      state.showShareRoles = data
    },
    SET_RIGHTS_CONTROL(state,data) {
      state.showRightsControl = data
    },
    SET_DEFAULT_VAL_RIGHTS(state,data) {
      state.defaultRight = data
    },
    SET_RIGHTS_TYPE(state,data) {
      state.rightsType = data
    },
    SET_SHOW_CHANGE_OWNER(state, data) {
      state.showChangeOwner = data
    },
    SET_RIGHTS_DEVICE_TYPE(state, data) {
      state.deviceType = data
    },
    SET_SHARE_DEVICE_TYPE(state,data) {
      state.shareDeviceType = data
    },
    SET_SETTINGS_NODE_EDITABLE(state,data) {
      state.onSettingsNodeEdit = data
    },
    SET_HEADER_SETTINGS_EDIT_ACTIVE(state,data) {
      state.isHeaderSettingsEditActive = data
    },
    SET_ON_EDITING_INPUTS(state,data) {
      state.onEditingInputs = data
    },
    SET_NEW_AVATAR(state,data) {
      state.newAvatar = data
    },
    SET_DISPLAYED_NOW_THINGS(state, data) {
      state.displayedNowThings = data
    },
  },
  actions: {

    //ПОЛУЧЕНИЕ
    //собственные вещи
    // async getOwnedDevices({state, commit,dispatch, rootState}, obj) {
    //   await axios({
    //     method: 'get',
    //     url: `${api}devices/get-owned-devices`,
    //     headers: {
    //       'Authorization': rootState.auth.token
    //     }
    //   }).then(res => {
    //     commit('SET_OWNED_THINGS', res.data)
    //   }).catch(e => {
    //     let res = e.response.data;
    //
    //     if (res.message.includes('access')) {
    //       dispatch('auth/logout', '', {root: true})
    //     }
    //   })
    // },
    //прикрепленные
    /*async getAssignedDevices({state,commit,dispatch, rootState}, obj) {
      await axios({
        method: 'get',
        url: `${api}devices/get-assigned-devices`,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(res => {
        commit('SET_ASSIGNED_THINGS', res.data)
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      })
    },*/
    //получить все вещи списком
    async getDevices({state,commit,dispatch, rootState}) {
      await axios({
        method: 'get',
        url: `${api}devices/get-owned`,
        headers: {
          'Authorization': rootState.auth.token
        }
      })
      .then(res => {
        // console.log('ниже res.data из getDevices Action (devices/get-owned)')
        // console.log(res.data)
        commit('SET_ALL_DEVICES', res.data)

        let tags_arr = [];

        for (let i = 0; i < res.data.length; i++) {
          for (let x = 0; x < res.data[i].tags.length; x++) {
            let is_unique = true;

            for (let y = 0; y < tags_arr.length; y++) {
              if(tags_arr[y].id == res.data[i].tags[x].id) {
                is_unique = false;
              }
            }

            if(is_unique) {
              tags_arr.push(res.data[i].tags[x]);
            }
          }
        }

        commit('SET_ALL_DEVICES_TAGS', tags_arr);
      })
    },
    //Получить одну вещь по id
    async getDevice({state,commit,dispatch, rootState}, id) {
      await axios({
        method: 'get',
        url: `${api}devices/get?id=${id}`,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(res => {
        if (res.data.length === 0) {
          router.push('/403');
          return
        };
        commit('SET_DEVICE', res.data)
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      })
    },

    // СОЗДАНИЕ
    //вещи
    async createDevice({state,dispatch,commit, rootState}, data) {
      await axios({
        method: 'post',
        url: `${api}devices/create`,
        data,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': rootState.auth.token
        }
      }).then((res) => {
        if (state.isMergeVirtual) {
          commit('SET_MERGE_VIRTUAL_ID', res.data.id);
        }

          dispatch('getDevices');

        data = res.data;

      }).catch(e => {
        let res = e.response.data;


        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      });
      return data
    },

    // АПДЕЙТ
    //вещи
    async updateDevice({state,commit,dispatch, rootState}, data) {
      await axios({
        method: 'post',
        url: `${api}devices/update`,
        data,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': rootState.auth.token
        }
      }).then(res => {
        this.newAvatar = '';
        dispatch('projects/getProjects', '', {root: true});
        dispatch('getDevices');
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };

        if (res.message.includes('You cannot include a device')) {
          throw new Error('error include')
        }
      })
    },

    //удаление аватара вещи
    async deleteDeviceIMG({state,commit,dispatch, rootState}, id) {
      await axios({
        method: 'post',
        url: `${api}devices/clear-image`,
        data: {
          id
        },
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(res => {
        this.newAvatar = ''
      })
    },

    // УДАЛЕНИЕ
    //вещи
    async deleteDevice({state,commit,dispatch, rootState}, id) {
      await axios({
        method: 'post',
        url: `${api}devices/delete`,
        data: {
          id
        },
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(res => {
        // if (state.activeSectionThings === 'owned') {
        //   dispatch('getOwnedDevices', {token: data.token});
        // } else  {
        //   dispatch('getAssignedDevices', {token: data.token})
        // }
      }).catch(e => {
        if (e.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      })
    },

    //ДОСТУПЫ
    async setPermissions({state,commit,dispatch, rootState}, obj) {
      await axios({
        method: 'post',
        url: `${api}permission/set`,
        data: obj.data,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(res => {
        dispatch('getDevices')
        // dispatch('getOwnedDevices', {token: obj.token});

        // let routeId = router.history.current.params.id;
        // console.log(routeId)

        // if (routeId) {
        //   if (!obj.noReload) {
        //     dispatch('getDevice', routeId)
        //   }
        // }

      })
        .catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      })
    },
    async removePermission({state,commit,dispatch, rootState}, obj) {
      await axios({
        method: 'post',
        url: `${api}permission/delete`,
        data: obj.data,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(res => {
        dispatch('getDevices')
      })
        .catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      })
    },
    setSettingsNodeEditable({commit}, payload) {
      commit('SET_SETTINGS_NODE_EDITABLE', payload)
      commit('SET_HEADER_SETTINGS_EDIT_ACTIVE', payload)
    },
    setEditedFields({commit}, payload) {
      commit('SET_ON_EDITING_INPUTS', payload)
    },
    setNewAvatar({commit}, payload) {
      commit('SET_NEW_AVATAR', payload)
    },


    // ТЕГИ
    async createDeviceTag({state,dispatch,commit, rootState}, obj) {
      let data;
      await axios({
        method: 'post',
        url: `${api}tags/set`,
        data: obj,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then((res) => {
        data = res.data;

      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      });
      return data
    },
    async unsetDeviceTag({state,dispatch,commit, rootState}, obj) {
      let data;
      await axios({
        method: 'post',
        url: `${api}tags/unset`,
        data: obj,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then((res) => {
        data = res.data;

      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      });
      return data
    },
    async deleteDeviceTag({state,dispatch,commit, rootState}, obj) {
      let data;
      await axios({
        method: 'post',
        url: `${api}tags/delete`,
        data: obj,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then((res) => {
        data = res.data;

      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      });
      return data
    },
    async getDeviceTags({state,commit,dispatch, rootState}, obj) {
      await axios({
        method: 'get',
        url: `${api}tags/get-for-device?device_id=${obj.id}`,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(res => {
      }).catch(e => {
      })
    },
    async addDeviceFile({state,dispatch,commit, rootState}, obj) {
      let data;
      await axios({
        method: 'post',
        url: `${api}devices/add-files`,
        data: obj,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': rootState.auth.token
        }
      }).then((res) => {
        data = res.data;

      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      });
      return data
    },
    async removeDeviceFile({state,dispatch,commit, rootState}, obj) {
      let data;
      await axios({
        method: 'post',
        url: `${api}devices/remove-files`,
        data: obj,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then((res) => {
        data = res.data;

      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      });
      return data
    },
  }
}
